<template>
  <div>
    <div class="home">
      <!-- 充值图片展示 -->
      <ul class="home_img">
        <li
          v-for="item in goodsList"
          :key="item.childCode"
          @click="recharge(item)"
          :class="{
            activeImg:
              item.childFee / 100 === activeImg.money && userList.isGd !== '0',
          }"
        >
          <img :src="imgRender(item)" :alt="item.childName" />
        </li>
      </ul>
      <!-- 立即办理 -->
      <van-button
        @click="handle"
        :class="{ home_btn: true, disabled: disabledBtn }"
      ></van-button>
      <!-- 登录弹层 -->
      <van-popup v-model="showLogin">
        <div class="wrapper">
          <div class="title">
            <p>尊敬的用户，您好：</p>
            <p>
              您正在参与充值返赠优惠活动，请输入手机号和短信验证码进行登录。
            </p>
          </div>
          <van-form @submit="onSubmit" class="wrapper_form" ref="loginRef">
            <van-field
              class="wrapper_field"
              v-model.trim="recieveNum"
              name="recieveNum"
              placeholder="请输入广电手机号码"
              :rules="[{ required: true }]"
            ></van-field>
            <div class="wrapper_captcha">
              <van-field
                v-model="loginCaptcha"
                class="wrapper_captcha_s"
                placeholder="请输入验证码"
                name="loginCaptcha"
                :rules="[
                  {
                    required: true,
                    message: '请输入验证码',
                    trigger: 'blur',
                  },
                ]"
              ></van-field>
              <van-button
                v-show="sendCaptcha"
                native-type="button"
                @click="getCaptcha"
                >获取验证码</van-button
              >
              <van-button disabled v-show="!sendCaptcha" native-type="button"
                >{{ count_down }}s后重新发送</van-button
              >
            </div>
            <div class="wrapper_checked">
              <van-field name="checked" :rules="[{ required: true }]">
                <template #input>
                  <van-checkbox
                    v-model="checked"
                    direction="horizontal"
                    class="wrapper_deal"
                    label-disabled
                  >
                    <span>查看并同意</span>
                    <span
                      class="agreement"
                      @click.stop="agreementGo('xy20220613000016')"
                      >《用户服务协议》</span
                    >
                    <span>、</span>
                    <span
                      class="agreement"
                      @click.stop="agreementGo('xy20220613000018')"
                      >《隐私保护政策》</span
                    >
                    <span>、</span>
                    <span
                      class="agreement"
                      @click.stop="agreementGo('xy20220914000053')"
                      >《线上售卡渠道反诈宣传》</span
                    >
                    <template #icon="props">
                      <img
                        class="img-icon"
                        :src="props.checked ? activeIcon : inactiveIcon"
                      />
                    </template>
                  </van-checkbox>
                </template>
              </van-field>
            </div>
            <van-button
              @click="checked ? '' : $toast.fail('未点击用户协议和隐私政策')"
              native-type="submit"
              class="login_btn"
            ></van-button>
          </van-form>
        </div>
      </van-popup>
      <!-- 办理套餐提示 -->
      <van-popup v-model="showVerify">
        <div class="wrapper verify">
          <div :class="!orderRender ? 'verify_p' : ''">
            <p>{{ utils.phoneDesensitization(recieveNum) }}用户，您好！</p>
            <p>
              您正在办理<span>“{{ activeImg.desc }}”</span>活动
            </p>
          </div>
          <div  class="wrapper_captcha">
            <van-field
              v-model="smsCaptcha"
              class="wrapper_captcha_s"
              placeholder="请输入验证码"
              name="smsCaptcha"
              :rules="[
                {
                  required: true,
                  message: '请输入验证码',
                  trigger: 'blur',
                },
              ]"
            ></van-field>
            <van-button
              v-show="sendCaptcha && orderRender"
              native-type="button"
              @click="getCaptcha"
              >获取验证码</van-button
            >
            <van-button disabled v-show="!sendCaptcha && orderRender" native-type="button"
              >{{ count_down }}s后重新发送</van-button
            >
             <van-button
              v-show="sendCaptcha && !orderRender"
              native-type="button"
              @click="getCaptchaH5"
              >获取验证码</van-button
            >
            <van-button disabled v-show="!sendCaptcha && !orderRender" native-type="button"
              >{{ count_down }}s后重新发送</van-button
            >
          </div>
          <van-button
            class="login_btn"
            :class="orderRender||true ? 'verify_btn' : 'h5_btn'"
            @click="smsVerify"
          ></van-button>
        </div>
        <van-button
          class="canclePackage"
          @click="showVerify = false"
        ></van-button>
      </van-popup>
      <!-- 支付 -->
      <van-popup
        v-model="showPay"
        position="bottom"
        class="pay"
        closeable
        close-icon-position="top-left"
        :close-icon="cancelBtn"
        safe-area-inset-bottom
        :close-on-click-overlay="false"
      >
        <p>充值金额</p>
        <div class="pay_money">
          <span>￥</span><span>{{ activeImg.money }}</span>
        </div>
        <hr />
        <p class="pay_text">支付方式</p>
        <van-radio-group v-model="payMethod">
          <van-cell-group>
            <van-cell v-if="!isWeiXin" clickable @click="payMethod = 'aliPay'">
              <template #title>
                <img src="../assets/payMoney/zhifubao.png" />
                <span>支付宝支付</span>
              </template>
              <template #right-icon>
                <van-radio name="aliPay">
                  <template #icon="props">
                    <img
                      class="img-icon"
                      :src="props.checked ? activePay : inactivePay"
                    />
                  </template>
                </van-radio>
              </template>
            </van-cell>
            <van-cell v-if="!isAliPay" clickable @click="payMethod = 'wxPay'">
              <template #title>
                <img src="../assets/payMoney/weixin.png" />
                <span>微信支付</span>
              </template>
              <template #right-icon>
                <van-radio name="wxPay">
                  <template #icon="props">
                    <img
                      class="img-icon"
                      :src="props.checked ? activePay : inactivePay"
                    />
                  </template>
                </van-radio>
              </template>
            </van-cell>
            <van-cell
              v-if="!isWeiXin && !isAliPay"
              clickable
              @click="payMethod = 'visaPay'"
            >
              <template #title>
                <img src="../assets/payMoney/yinlian.png" />
                <span>银联支付</span>
              </template>
              <template #right-icon>
                <van-radio name="visaPay">
                  <template #icon="props">
                    <img
                      class="img-icon"
                      :src="props.checked ? activePay : inactivePay"
                    />
                  </template>
                </van-radio>
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-button @click="payForMoney"></van-button>
      </van-popup>
      <!-- 已参与活动modal -->
      <van-popup v-model="isAttendModal" :close-on-click-overlay="false">
        <div class="tips">
          <p>尊敬的用户，您好：</p>
          <p class="text1">
            您已参加过本次活动，无法重复参加，感谢您的理解与支持。
          </p>
          <p class="text" v-if="orderRender">
            您可进入“我的订单”页，查看本活动的订单状态及详情。
          </p>
          <div class="tips_text" v-if="!orderRender">
            <p class="text">您可登录：</p>
            <p class="text">
              中国广电网上营业厅、微信/支付宝小程序中国广电营业厅，进入“我的订单”页，查看本活动的订单状态及详情。
            </p>
          </div>
          <van-button
            class="backHome"
            v-if="orderRender"
            @click="BackToHome"
          ></van-button>
        </div>
      </van-popup>
      <!-- 存在待支付订单modal -->
      <van-popup v-model="isExistOrder">
        <div class="tips">
          <p>尊敬的用户，您好：</p>
          <p class="tips_text" v-if="orderRender">
            您已有相似订单，无法重复参加，您可进入订单页，查询订单详情。
          </p>
          <p class="text1" v-if="!orderRender">
            您已有相似订单，无法重复参加，您可登录中国广电网上营业厅、微信/支付宝小程序中国广电营业厅，查询订单详情。
          </p>
          <van-button
            :class="orderRender ? 'checkOrder' : 'ok'"
            @click="existOrder"
          ></van-button>
        </div>
      </van-popup>
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script>
import {
  getVerify,
  getVerifyH5,
  smsLogin,
  sessionLogin,
  getOpenId,
  getSignature,
  getChannelInfo
} from '@/api/login'
import { pay } from '@/common'
import {
  rechargeStall,
  isAttendAct,
  submitOrder,
  submitOrderH5,
  pendingPayOrder,
  insert,
  checkSmsCode,
  checkSmsCodeH5
} from '@/api/rechargeAct'
import { isIos, isAndroid, isWeiXin, isAliPay, isWeiXinA } from '@/utils'
import utils from '@/utils/validator'
import { mapGetters } from 'vuex'

export default {
  name: 'HomeView',
  data() {
    return {
      disabledBtn: false,
      isClient: isIos || isAndroid,
      isWeiXin,
      isAliPay,
      sessionId: '', //用户信息标识
      recieveNum: '', //接受手机号码
      channelId: '', //渠道标识
      tfChannelId: '',
      loginCaptcha: '', //登录验证码
      smsCaptcha: '', //短信验证码
      checked: false, //是否选中条例
      activePay: require('../assets/payMoney/checked.png'), //选中支付样式
      inactivePay: require('../assets/payMoney/nocheck.png'), //未选中支付样式
      activeIcon: require('@/assets/checked.png'), //选中图标样式
      inactiveIcon: require('@/assets/nocheck.png'), //未选中样式
      cancelBtn: require('@/assets/payMoney/cancel.png'), //支付取消样式
      showPay: false,
      payMethod: 'aliPay', //支付方式
      userList: {}, //用户信息
      utils,
      sendCaptcha: true, //获取验证码
      count_down: 0, //倒计时
      activeImg: {
        money: 0,
        desc: '',
      }, //选中图片
      goodsList: [
        {
          childFee: 5000,
          showType: '0',
        },
        {
          childFee: 10000,
          showType: '0',
        },
        {
          childFee: 20000,
          showType: '0',
        },
        {
          childFee: 30000,
          showType: '0',
        },
      ], //档位信息数据
      //新状态标识
      showVerify: false, //二次短信验证弹窗
      isAttend: false, //是否已参与活动
      isAttendModal: false, //是否参与过活动弹窗
      isExistOrder: false, //存在订单弹窗
      appid: 'wx5ac2a47e59d607da',
      openid: '',
      code: '',
      productId:'',
      token:'',
      smsCaptchaTemp:''
    }
  },
  computed: {
    showLogin: {
      set(status) {
        this.$store.dispatch('emitShowLogin', { status }).then(() => {})
      },
      get() {
        return this.$store.state.showLogin
      },
    },
    imgRender() {
      return ({ childFee, showType }) => {
        const money = childFee / 100
        if (showType === '1' || this.userList.isGd === '0') {
          return require(`../assets/forbid/forbid_${money}.png`)
        } else {
          return require(`../assets/default/default_${money}.png`)
        }
      }
    },
    orderRender() {
      console.log(this.isClient,'this.isClient');
      console.log(isWeiXin,'this.isWeiXin');
      console.log(isAliPay,'this.isAliPay');
      
      return this.isClient || isWeiXin || isAliPay
    },
    ...mapGetters(['userInfo']),
  },
  watch: {
    showLogin(status) {
      if (!status) {
        this.sendCaptcha = true
        this.loginCaptcha = ''
      }
    },
    showVerify(status) {
      if (!status) {
        this.sendCaptcha = true
        this.smsCaptcha = ''
      }
    },
    userInfo: {
      handler(val) {
        if (val.sessionId) {
          this.sessionId = val.sessionId
          this.recieveNum = val.accessNum
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    //套餐档位切换
    recharge({ showType, childFee, childName,childCode }) {
      if (!this.sessionId) {
        this.$store.dispatch('emitShowLogin', { status: true }).then(() => {})
        return
      }
      if (showType === '0') {
        this.activeImg = {
          money: childFee / 100,
          desc: childName,
        }
      }
      console.log(childCode,'childCode');
      
    },

    //发送验证码
    sendCode() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      })
      getVerify({
        recieveNum: this.recieveNum,
        channelId: this.channelId,
        type: '1',
      })
        .then((res) => {
          this.$toast.clear()
          //倒计时
          res.respDesc ? this.$toast(res.respDesc) : this.$toast('短信发送成功')
          this.sendCaptcha = false
          this.count_down = 60
          let timer = setInterval(() => {
            this.count_down--
            if (this.count_down <= 0) {
              this.sendCaptcha = true
              clearInterval(timer)
            }
          }, 1000)
        })
        .catch((res) => {
          this.$toast.clear()
          res.message && this.$toast(res.message)
        })
    },

    //获取验证码
    async getCaptcha() {
      if (this.showLogin) {
        //登录弹窗
        if (!this.recieveNum) {
          this.$toast('请输入手机号码')
          return
        }
        if (!utils.validatePhone(this.recieveNum)) {
          this.$toast('手机号码格式有误，请重新输入')
          return
        }
        this.sendCode()
      } else {
        //APP||小程序二次短信校验
        this.sendCode()
      }
    },

    //获取验证码
    async getCaptchaH5() {
       const res = this.goodsList.filter(
          (item) => item.childFee / 100 === this.activeImg.money && item
        )
        console.log(res,'res');
      this.productId = res[0].productId;
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      })
      getVerifyH5({
        phone: this.recieveNum,
        channelId: this.channelId,
        sessionId:this.sessionId,
        offerCode: this.productId,
      })
        .then((res) => {
          this.$toast.clear()
          //倒计时
          res.respDesc ? this.$toast(res.respDesc) : this.$toast('短信发送成功')
          this.sendCaptcha = false
          this.count_down = 60
          let timer = setInterval(() => {
            this.count_down--
            if (this.count_down <= 0) {
              this.sendCaptcha = true
              clearInterval(timer)
            }
          }, 1000)
        })
        .catch((res) => {
          this.$toast.clear()
          res.message && this.$toast(res.message)
        })
    },

     smsVerifyH5() {
     
      
      if (!this.orderRender) {
        //H5检验
        if (!this.smsCaptcha) {
          this.$toast('请输入验证码')
          return
        }
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
        })
        checkSmsCodeH5({
          accessNum: this.recieveNum,
            channelId: this.channelId,
            smsCode: this.smsCaptcha, // 短信验证码
            sessionId: this.sessionId 
        })
          .then(async (res) => {
            console.log(res,'res222');
            this.smsCaptchaTemp = JSON.parse(JSON.stringify(this.smsCaptcha));;
            this.token = res;
            this.$toast.clear()
            this.showVerify = false
             this.showPay = true
          })
          .catch(() => {
            this.$toast.clear()
            this.$toast('验证码错误，请重新输入')
          })
      } 
    },


    //查询是否参与过活动
    async isAttendAct() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      })
      rechargeStall({
        channelId: this.channelId,
        phoneNumber: this.recieveNum,
        sessionId: this.sessionId,
      })
        .then((res) => {
          // 档位信息数据(小=>大)
          this.goodsList = res.goodsList
            .map((item) => item.goodsChildList && item.goodsChildList[0])
            .reverse()
          let chosenGoods = this.goodsList.filter(
              (item) => item.showType === '0'
            ),
            len = chosenGoods.length
          this.activeImg = {
            money: chosenGoods[len - 1].childFee / 100,
            desc: chosenGoods[len - 1].childName,
          }
          return isAttendAct({
            channelId: this.channelId,
            phoneNumber: this.recieveNum,
            sessionId: this.sessionId,
          })
        })
        .then((data) => {
          this.$toast.clear()
          if (data) {
            this.isAttend = false
            this.isAttendModal = false
          } else {
            this.isAttend = true
            this.isAttendModal = true
          }
        })
        .catch((res) => {
          this.$toast.clear()
          if (res.message.indexOf('参与过') > -1) {
            this.isAttend = true
            this.isAttendModal = true
          } else if (
            res.message.indexOf('副卡') > -1 ||
            res.message.indexOf('停机') > -1 ||
            res.message.indexOf('欠费') > -1
          ) {
            res.message && this.$toast(res.message)
            this.disabledBtn = true
          } else if (res.message.indexOf('无数据') > -1) {
            res.message && this.$toast(res.message)
            this.goodsList = this.goodsList.map((item) => ({
              ...item,
              ...{ showType: '1' },
            }))
          } else if (res.message.indexOf('非广电') > -1) {
            res.message && this.$toast('您好，本次优惠活动仅面向广电192用户')
            this.disabledBtn = true
          } else if (res.message.indexOf('childFee') > -1) {
            res.message &&
              this.$toast('您好，本次优惠活动主副卡用户仅主卡能参与')
            this.disabledBtn = true
          } else {
            res.message && this.$toast(res.message)
            this.disabledBtn = true
          }
        })
    },

    //登录验证
    onSubmit() {
      this.$refs.loginRef
        .validate()
        .then(async () => {
          //短信验证码登录
          this.$toast.loading({
            message: '正在登录',
            duration: 0,
            forbidClick: true,
          })
          smsLogin({
            loginType: '1',
            loginPhone: this.recieveNum,
            loginPassWord: this.loginCaptcha,
            channelType: '1',
            channelId: this.channelId,
          })
            .then(({ sessionId }) => {
              this.sessionId = sessionId
              return sessionLogin({
                accessNum: this.recieveNum,
                sessionId: this.sessionId,
              })
            })
            .then((info) => {
              //获取用户信息
              this.userList = info
              this.$toast.clear()
              this.$toast.success({
                message: '登录成功',
                forbidClick: true,
                onClose: async () => {
                  //验证通过
                  this.$store
                    .dispatch('emitShowLogin', { status: false })
                    .then(() => {})
                  this.$store.dispatch('emitSetUserInfo', info)
                  //查询是否参与过活动
                  await this.isAttendAct()
                },
              })
            })
            .catch((res) => {
              this.$toast.clear()
              res.message && this.$toast(res.message)
            })
        })
        .catch(() => {})
    },

    //立即办理弹出提示框
    async handle() {
      if (this.disabledBtn) return
      if (!this.sessionId && Object.keys(this.userInfo).length === 0) {
        this.$store.dispatch('emitShowLogin', { status: true }).then(() => {})
        return
      }
      if (!this.activeImg.money) {
        this.$toast('请选择套餐')
        return
      }
      //判断是否参与过活动
      if (this.isAttend) {
        this.isAttendModal = true
      } else {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
        })
        //查询是否存在待支付订单
        pendingPayOrder({
          channelType: '1',
          channelId: this.channelId,
          sessionId: this.sessionId,
          phone: this.recieveNum,
          orderStatusArray: '1',
          payStatusArray: '0',
          orderTypesArray: '24',
          pageNum: 1,
          pageSize: 10,
        })
          .then(({ total = 0 }) => {
            this.$toast.clear()
            if (total > 0) {
              //存在待支付订单
              this.isExistOrder = true
            } else {
              //不存在待支付订单
              this.showVerify = true
            }
          })
          .catch((res) => {
            this.$toast.clear()
            res.message && this.$toast(res.message)
          })
      }
    },

    //办理套餐提示确认
    smsVerify() {
      if (this.orderRender) {
        //广电自有触电
        if (!this.smsCaptcha) {
          this.$toast('请输入验证码')
          return
        }
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
        })
        checkSmsCode({
          accessNum: this.recieveNum,
            channelId: this.channelId,
            smsCode: this.smsCaptcha, // 短信验证码
            type: '1' // 验证码类型
        })
          .then(async () => {
            this.$toast.clear()
            this.showVerify = false
            if (isWeiXin || isAliPay) {
              await this.submitsOrder()
            } else {
              this.showPay = true
            }
          })
          .catch(() => {
            this.$toast.clear()
            this.$toast('验证码错误，请重新输入')
          })
      } else {
           // H5支付逻辑
        this.smsVerifyH5();
     
        // this.showVerify = false
        // this.showPay = true
      }
    },

    async payForMoney() {
      this.showPay = false
      if(this.orderRender){
        await this.submitsOrder()
      }else {
        await this.submitsOrderH5()
      }
      
    },

    //提交订单
    async submitsOrder() {
      try {
        const res = this.goodsList.filter(
          (item) => item.childFee / 100 === this.activeImg.money && item
        )
        this.$toast.loading({
          message: '订单创建中，请稍后',
          duration: 0,
          forbidClick: true,
        })
        const orderId = await submitOrder({
          sessionId: this.sessionId,
          orderType: '24',
          channelId: this.channelId,
          channelType: '1',
          areaCode: this.userList.phoneInfo.areaCode,
          areaName: this.userList.phoneInfo.mgmtProvName,
          regionCode: this.userList.phoneInfo.mgmtProv,
          cityCode: this.userList.phoneInfo.mgmtDistrict,
          cityName: this.userList.phoneInfo.mgmtDistrictName,
          phone: this.userList.phoneInfo.accessNumber,
          userIdType: '1',
          userId: this.userList.phoneInfo.accessNumber,
          payMoney: parseInt(this.activeImg.money),
          sendWay: '3',
          goodsParams: {
            goodsId: res[0].goodsId,
            goodsSkuId: res[0].id,
            orderNum: '1',
            action: '0',
          },
          acctInfo: {
            acctType: '1',
            prestoreFee: '0',
            cardFee: '0',
            invoiceMode: '1',
          },
          rechargeMoney: parseInt(this.activeImg.money),
        })
        this.$toast.clear()
        if (isWeiXin || isAliPay) {
          pay({
            orderId: orderId,
            orderPaySum: this.activeImg.money,
          })
        } else {
          pay({
            channelId: this.channelId,
            orderId: orderId,
            sessionId: this.sessionId,
            regionId: this.userList.phoneInfo.areaCode,
            accessNum: this.recieveNum,
            type: this.payMethod,
            openid: this.openid,
          })
        }
      } catch (e) {
        this.$toast.clear()
        e.message && this.$toast(e.message)
      }
    },

      //提交订单
    async submitsOrderH5() {
      try {
        const res = this.goodsList.filter(
          (item) => item.childFee / 100 === this.activeImg.money && item
        )
        this.$toast.loading({
          message: '订单创建中，请稍后',
          duration: 0,
          forbidClick: true,
        })
        const orderId = await submitOrderH5({
          sessionId: this.sessionId,
          orderType: '24',
          channelId: this.channelId,
          channelType: '1',
          areaCode: this.userList.phoneInfo.areaCode,
          areaName: this.userList.phoneInfo.mgmtProvName,
          regionCode: this.userList.phoneInfo.mgmtProv,
          cityCode: this.userList.phoneInfo.mgmtDistrict,
          cityName: this.userList.phoneInfo.mgmtDistrictName,
          phone: this.userList.phoneInfo.accessNumber,
          userIdType: '1',
          userId: this.userList.phoneInfo.accessNumber,
          payMoney: parseInt(this.activeImg.money),
          sendWay: '3',
          goodsParams: {
            goodsId: res[0].goodsId,
            goodsSkuId: res[0].id,
            orderNum: '1',
            action: '0',
          },
          acctInfo: {
            acctType: '1',
            prestoreFee: '0',
            cardFee: '0',
            invoiceMode: '1',
          },
          rechargeMoney: parseInt(this.activeImg.money),
          smsCode:this.smsCaptchaTemp,
          token:this.token
        })
        this.$toast.clear()
        if (isWeiXin || isAliPay) {
          pay({
            orderId: orderId,
            orderPaySum: this.activeImg.money,
          })
        } else {
          pay({
            channelId: this.channelId,
            orderId: orderId,
            sessionId: this.sessionId,
            regionId: this.userList.phoneInfo.areaCode,
            accessNum: this.recieveNum,
            type: this.payMethod,
            openid: this.openid,
          })
        }
      } catch (e) {
        this.$toast.clear()
        e.message && this.$toast(e.message)
      }
    },

    //回到首页
    BackToHome() {
      this.isAttendModal = false
      if (isAndroid || isIos) {
        if (isIos) {
          window.webkit.messageHandlers.nativeCall.postMessage({
            type: 'backClassify',
          })
        } else {
          window.android.nativeCall(JSON.stringify({ type: 'backClassify' }))
        }
      } else if (isWeiXin || isAliPay) {
        if (isWeiXin) {
          window.wx.miniProgram.navigateBack({
            delta: 2,
          })
        } else {
          window.my.navigateBack({
            delta: 2,
          })
        }
      }
    },

    //存在订单模态框按钮
    existOrder() {
      if (this.orderRender) {
        //  查看订单列表
        if (isAndroid || isIos) {
          window.location.href =
            'https://app.10099.com.cn/h5-app/#/pages/order/orderList/index'
        } else if (isWeiXin || isAliPay) {
          if (isWeiXin) {
            window.wx.miniProgram.navigateTo({
              url: '/pages/order/orderList/index',
            })
          } else {
            window.my.navigateTo({ url: '/pages/order/orderList/index' })
          }
        }
      } else {
        this.isExistOrder = false
      }
    },

    //页面访问统计
    visitStatistics(tfChannelId) {
      insert({
        channelId: this.channelId,
        tfChannelId,
        pageUrl: window.location.href,
        pageLabel: 'homePage',
        eventLabel: 'visit',
      })
        .then((res) => {
          console.log(res)
        })
        .catch((error) => {
          console.log(error)
        })
    },

    //获取code
    getCode(name) {
      console.log('window.location.search', window.location.search)
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return decodeURI(r[2])
      return null
    },

    //微信授权
    async wxLogin() {
      let url = encodeURIComponent(window.location.href)
      this.code = this.getCode('code')
      console.log('this.code===========>', this.code)
      if (!this.code && !sessionStorage.getItem('wxOpenCode')) {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
      } else {
        if (this.code) {
          sessionStorage.setItem('wxOpenCode', this.code)
        }
        console.log(this.code)
        this.getOpenId()
      }
    },

    //获取openid
    async getOpenId() {
      try {
        const { openid } = await getOpenId({
          code: this.code,
          paramCode: 'WXGZH',
        })
        console.log(openid)
        this.openid = openid
      } catch (error) {
        console.log(error)
      }
    },
    //协议跳转
    agreementGo(id) {
      this.showLogin = false
      this.$router.push({
        path: 'agreeMent',
        query: {
          id,
        },
      })
    },
  },
  async created() {
    console.log(window.location.href)
    const {
      sessionId = '',
      channelId = 'cd_20220905_841217',
      accessNum = '',
      title = '',
      tfChannelId = '',
    } = this.$route.query
    sessionStorage.setItem('channelId', channelId)
    let userInfo = {}
    if (localStorage.getItem('JHUserInfo')) {
      userInfo = JSON.parse(JSON.parse(localStorage.getItem('JHUserInfo')).data)
    }
    if (Object.keys(userInfo).length === 0) {
      this.sessionId = sessionId
      this.recieveNum = accessNum
    }

    this.channelId = sessionStorage.getItem('channelId') || channelId
    this.tfChannelId = tfChannelId
    if (channelId) {
      if (channelId.indexOf('cd_') > -1) {
        this.tfChannelId = channelId
      } else {
        let res = await getChannelInfo({ channelInfo: channelId })
        this.tfChannelId = res.tfChannelId || ''
        this.channelId = this.tfChannelId
      }
    }
    if (title) {
      document.title = title
    }
    //获取客户端留存用户信息
    if (isIos) {
      this.channelId = 'cd_20220626_540692'
      if (document.cookie) {
        let aCookie = document.cookie.split('; ')
        let result = aCookie.find((val) => val.indexOf('cbn_info=') > -1)
        if (result) {
          const [sessionId, , accessNumber, , , , , loginPhone = '', ,] = result
            .split('=')[1]
            .split(',')
          this.sessionId = sessionId
          this.recieveNum = accessNumber || loginPhone
        }
      }
    } else if (isAndroid) {
      this.channelId = 'cd_20220516_503441'
      let loginInfo = window.prompt(JSON.stringify({ type: 'token' }))
      if (loginInfo) {
        let { type = '', data = {} } = JSON.parse(loginInfo)
        if (type === 'token') {
          const {
            sessionId,
            phoneInfo: { accessNumber, loginPhone = '' },
          } = data
          this.sessionId = sessionId
          this.recieveNum = accessNumber || loginPhone
        }
      }
    }
    //判断是否需要单点
    if (this.sessionId) {
      //根据sessionId自动登录
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      })
      const userInfo = await sessionLogin({
        accessNum: this.recieveNum,
        sessionId: this.sessionId,
      })
      this.$store.dispatch('emitSetUserInfo', userInfo)
      this.userList = userInfo
      this.$toast.clear()
      //查询是否参与过活动
      await this.isAttendAct()
    }
    this.visitStatistics(this.tfChannelId || this.channelId)
  },
  mounted() {
    if (isWeiXinA && !isWeiXin) {
      this.wxLogin()
      let str = utils.getUUID()
      let time = Date.now()
      getSignature({
        paramCode: 'WXGZH',
        noncestr: str,
        timeStamp: time,
        url: window.location.href.split('?')[0],
      })
        .then((res) => {
          console.log(res)
          wx.config({
            debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
            appId: this.appid, // 必填，公众号的唯一标识
            timestamp: time, // 必填，生成签名的时间戳
            nonceStr: str, // 必填，生成签名的随机串
            signature: res, // 必填，签名
            jsApiList: ['chooseWXPay'], // 必填，需要使用的 JS 接口列表
          })
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
}
</script>

<style scoped lang="less">
.home {
  position: relative;
  width: 750px;
  min-height: 1452px;
  background: url('../assets/background1.png') no-repeat;
  background-size: 100%;
  img {
    width: 100%;
    height: 100%;
  }
  .home_img {
    width: 750px;
    height: 600px;
    position: absolute;
    top: 730px;
    left: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: space-around;
    padding: 100px 85px 90px 85px;
    li {
      width: 288px;
      height: 198px;
      border: 5px solid transparent;
      border-radius: 20px;
      overflow: hidden;
      &.activeImg {
        border-color: #ffc771;
        box-shadow: 0px 0px 20px #ffc771;
        transform: scale(1.1);
      }
    }
  }
  .home_btn {
    width: 514px;
    height: 110px;
    background: url('../assets/button.png') no-repeat center center;
    background-size: 100%;
    border: none;
    position: absolute;
    left: 120px;
    top: 1300px;
    &.disabled {
      width: 514px;
      height: 110px;
      background: url('../assets/disabled.png') no-repeat center center;
      background-size: 100%;
      border: none;
      position: absolute;
      left: 120px;
      top: 1300px;
    }
  }
}
.bottom {
  width: 750px;
  min-height: 2494px;
  background: url('../assets/background2.png');
  background-size: 100%;
}
.van-popup {
  background-color: transparent;
}
// 登录弹层
.wrapper {
  position: relative;
  width: 8.08rem;
  min-height: 10.04rem;
  background: url('../assets/login.png');
  background-size: 100%;
  padding: 1.3067rem 0.625rem 0 0.74rem;
  .title {
    p {
      font-size: 0.3733rem;
      font-weight: bold;
      color: #973728;
      line-height: 0.64rem;
      &:last-child {
        margin-bottom: 0.2067rem;
      }
    }
  }
  .wrapper_field {
    width: 6.76rem;
    height: 1.1333rem;
    background: #fbeedc;
    border: 0.0133rem solid #e59a65;
    border-radius: 0.1333rem;
  }
  .van-button {
    width: 3.1467rem;
    height: 1.04rem;
    background: #e64645;
    border-radius: 0.1333rem;
    font-size: 0.3733rem;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #fff6ae;
    line-height: 0.64rem;
  }
  .wrapper_captcha {
    display: flex;
    margin-top: 0.3467rem;
    .wrapper_captcha_s {
      width: 3.3067rem;
      height: 1.0533rem;
      background: #fbeedc;
      border: 1px solid #e59a65;
      border-radius: 0.1333rem;
      margin-right: 0.3067rem;
    }
  }
  .wrapper_deal {
    font-size: 0.32rem;
    line-height: 0.48rem;
    margin-top: 0.5467rem;
    align-items: flex-start;
    padding: none;
    span {
      color: #b78d5a;
    }
    .agreement {
      color: #e64645;
    }
    .img-icon {
      width: 0.3733rem;
      height: 0.3733rem;
    }
  }
  .wrapper_checked {
    :deep(.van-cell) {
      padding: 0;
    }
  }
  .login_btn {
    width: 7.76rem;
    height: 1.7467rem;
    margin-top: 0.2067rem;
    background: url('../assets/confirm.png') no-repeat;
    background-size: 100%;
    border: none;
    position: absolute;
    left: 0.2067rem;
  }
}
.verify {
  padding: 0.9067rem 0.625rem 0 0.74rem;
  min-height: 7.9733rem;
  background: url('../assets/Participated.png') no-repeat;
  background-size: 100%;
  p {
    font-size: 0.3733rem;
    color: #973728;
    line-height: 0.64rem;
    font-weight: bold;
    span {
      color: #e64a4a;
      font-size: 0.4267rem;
    }
  }
  .login_btn {
    margin-top: 1.5067rem;
    background: url('../assets/submit.png') no-repeat;
    background-size: 100%;
  }
  .verify_btn {
    margin-top: 0.4067rem;
  }
  .h5_btn {
    margin-top: 1.4067rem;
  }
  .verify_p {
    p {
      margin-top: 10px;
    }
  }
}
.tips {
  position: relative;
  width: 8.0667rem;
  height: 551px;
  background: url('../assets/isPay.png') no-repeat;
  background-size: contain;
  padding: 1.2467rem 0.64rem;
  p {
    font-size: 28px;
    font-family: HiraginoSansGB-W6;
    font-weight: bold;
    color: #973728;
    line-height: 48px;
  }
  .text1 {
    margin-top: 0.3333rem;
  }
  .tips_text {
    margin-top: 0.38rem;
  }
  .text {
    font-weight: 300;
    font-size: 24px;
  }
  .van-button {
    width: 7.76rem;
    height: 1.9867rem;
    margin-top: 0.44rem;
    border: none;
    position: absolute;
    left: 0.2067rem;
  }
  //查看订单
  .checkOrder {
    height: 1.84rem;
    margin-top: 1.34rem;
    background: url('../assets/result/checkOrder.png') no-repeat;
    background-size: 100%;
  }
  //返回首页
  .backHome {
    background: url('../assets/back_btn.png') no-repeat;
    background-size: 100%;
  }
  //好的
  .ok {
    margin-top: 0.9rem;
    background: url('../assets/result/ok.png') no-repeat;
    background-size: 100%;
  }
}
.pay {
  width: 9.9867rem;
  height: 900px;
  background: linear-gradient(0deg, #f7d0a1, #fae3c4);
  border-radius: 0.2667rem 0.2667rem 0 0;
  white-space: nowrap;
  :deep(.van-icon__image) {
    width: 0.3333rem;
    height: 0.32rem;
  }
  p {
    font-size: 0.4rem;
    color: #1a1a1a;
    line-height: 0.64rem;
    margin: 0.64rem 4.1867rem 0.6133rem 4.1867rem;
  }
  .pay_money {
    margin: 0 3.7467rem 0.4667rem 3.7467rem;
    span {
      font-size: 0.4933rem;
      color: #1a1a1a;
      line-height: 0.7733rem;
      &:last-of-type {
        font-size: 0.9733rem;
      }
    }
  }
  hr {
    margin: auto;
    width: 8.8533rem;
    height: 0.0267rem;
    background: #ffffff;
    border: 1px solid #973728;
    opacity: 0.42;
  }
  .pay_text {
    font-size: 0.32rem;
    color: #848484;
    line-height: 0.64rem;
    margin: 0.6133rem 0 0 0.5333rem;
  }
  .van-radio-group {
    img {
      width: 0.7467rem;
      height: 0.7467rem;
      vertical-align: middle;
    }
    span {
      font-size: 0.3733rem;
      color: #1a1a1a;
      line-height: 0.64rem;
      margin-left: 0.3467rem;
    }
    .img-icon {
      height: 0.4533rem;
      object-fit: contain;
    }
  }
  .van-button {
    width: 8.7467rem;
    height: 2.1733rem;
    margin-top: 0.7067rem;
    background: url('../assets/payMoney/pay_btn.png') no-repeat;
    background-size: 100%;
    border: none;
    position: absolute;
    left: 0.7067rem;
  }
}
:deep(.van-button--normal) {
  padding: 0;
}
:deep(.van-cell-group) {
  background-color: transparent;
}
:deep(.van-cell) {
  background-color: transparent;
}
:deep(.van-cell::after) {
  border: none;
}
:deep(.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after) {
  border: none;
}

//办理套餐关闭按钮
.canclePackage {
  width: 0.8rem;
  height: 0.8rem;
  background: url('../assets/cancle.png');
  background-size: 100%;
  position: absolute;
  left: 3.6667rem;
  top: 7.1333rem;
  border: none;
  opacity: 0.7;
}
</style>
